import { requiredRCPOAttributes } from '@components/_rcpo-v6/ProductOverview/hooks/use-rcpo-data'
import { Article } from '@generated'

export function getRcpoModelPrimaryAttributes(data: Article) {
  let attributes = []

  for (const id of requiredRCPOAttributes) {
    const attribute = data?.articleAttributes?.find((attribute) => attribute?.attributeID === id)

    if (attribute && attribute.attributeValue) {
      attributes.push(attribute.attributeValue)
    }
  }

  return attributes.join(', ')
}
